import { computed, ref } from 'vue';
import { defineStore } from 'pinia';

import { useActivityDetailsStore } from '@apps/main/new-desktop/core/stores';

import type { Marker, Rectangle } from '@libs/maps';

import {
  getInitialMapView,
  getMapMarker,
  getMapMarkerFormatters,
} from './activityDetailsMapStoreLogic';

export const useActivityDetailsMapStore = defineStore(
  'ActivityDetailsMapStore',
  () => {
    const activityDetailsStore = useActivityDetailsStore();

    // State
    const shouldShowFullscreenMap = ref<boolean>(false);

    // Actions
    function openDynamicMapModal(): void {
      shouldShowFullscreenMap.value = true;
    }

    function closeDynamicMapModal(): void {
      shouldShowFullscreenMap.value = false;
    }

    // Getters
    const mapMarker = computed<Marker | undefined>(() =>
      getMapMarker(activityDetailsStore.activityDetailsStaticData)
    );

    const initialMapView = computed<Rectangle | undefined>(() =>
      getInitialMapView(activityDetailsStore.activityDetailsStaticData)
    );

    return {
      // State
      shouldShowFullscreenMap,

      // Actions
      closeDynamicMapModal,
      openDynamicMapModal,
      getMapMarkerFormatters,

      // Getters
      mapMarker,
      initialMapView,
    };
  }
);
